//# sourceMappingURL=colors.mjs.map
/// <reference types="./colors.d.mts" />
import { CustomType as $CustomType } from "../gleam.mjs";

export class Colors extends $CustomType {
  constructor(transparent, text_white, text_body, text_display, gradient, grey_50, grey_100, grey_200, grey_400, grey_600, grey_800, cream_50, cream_100, cream_200, cream_400, cream_600, cream_800, foam_50, foam_100, foam_200, foam_400, foam_600, foam_800, error_50, error_100, error_200, error_400, error_600, error_800, success_50, success_100, success_200, success_400, success_600, success_800, blue_50, blue_100, blue_200, blue_400, blue_600, blue_800, ai_50, ai_100, ai_200, ai_400, ai_600, ai_800, warning_50, warning_100, warning_200, warning_400, warning_600, warning_800) {
    super();
    this.transparent = transparent;
    this.text_white = text_white;
    this.text_body = text_body;
    this.text_display = text_display;
    this.gradient = gradient;
    this.grey_50 = grey_50;
    this.grey_100 = grey_100;
    this.grey_200 = grey_200;
    this.grey_400 = grey_400;
    this.grey_600 = grey_600;
    this.grey_800 = grey_800;
    this.cream_50 = cream_50;
    this.cream_100 = cream_100;
    this.cream_200 = cream_200;
    this.cream_400 = cream_400;
    this.cream_600 = cream_600;
    this.cream_800 = cream_800;
    this.foam_50 = foam_50;
    this.foam_100 = foam_100;
    this.foam_200 = foam_200;
    this.foam_400 = foam_400;
    this.foam_600 = foam_600;
    this.foam_800 = foam_800;
    this.error_50 = error_50;
    this.error_100 = error_100;
    this.error_200 = error_200;
    this.error_400 = error_400;
    this.error_600 = error_600;
    this.error_800 = error_800;
    this.success_50 = success_50;
    this.success_100 = success_100;
    this.success_200 = success_200;
    this.success_400 = success_400;
    this.success_600 = success_600;
    this.success_800 = success_800;
    this.blue_50 = blue_50;
    this.blue_100 = blue_100;
    this.blue_200 = blue_200;
    this.blue_400 = blue_400;
    this.blue_600 = blue_600;
    this.blue_800 = blue_800;
    this.ai_50 = ai_50;
    this.ai_100 = ai_100;
    this.ai_200 = ai_200;
    this.ai_400 = ai_400;
    this.ai_600 = ai_600;
    this.ai_800 = ai_800;
    this.warning_50 = warning_50;
    this.warning_100 = warning_100;
    this.warning_200 = warning_200;
    this.warning_400 = warning_400;
    this.warning_600 = warning_600;
    this.warning_800 = warning_800;
  }
}
export const Colors$Colors = (transparent, text_white, text_body, text_display, gradient, grey_50, grey_100, grey_200, grey_400, grey_600, grey_800, cream_50, cream_100, cream_200, cream_400, cream_600, cream_800, foam_50, foam_100, foam_200, foam_400, foam_600, foam_800, error_50, error_100, error_200, error_400, error_600, error_800, success_50, success_100, success_200, success_400, success_600, success_800, blue_50, blue_100, blue_200, blue_400, blue_600, blue_800, ai_50, ai_100, ai_200, ai_400, ai_600, ai_800, warning_50, warning_100, warning_200, warning_400, warning_600, warning_800) =>
  new Colors(transparent,
  text_white,
  text_body,
  text_display,
  gradient,
  grey_50,
  grey_100,
  grey_200,
  grey_400,
  grey_600,
  grey_800,
  cream_50,
  cream_100,
  cream_200,
  cream_400,
  cream_600,
  cream_800,
  foam_50,
  foam_100,
  foam_200,
  foam_400,
  foam_600,
  foam_800,
  error_50,
  error_100,
  error_200,
  error_400,
  error_600,
  error_800,
  success_50,
  success_100,
  success_200,
  success_400,
  success_600,
  success_800,
  blue_50,
  blue_100,
  blue_200,
  blue_400,
  blue_600,
  blue_800,
  ai_50,
  ai_100,
  ai_200,
  ai_400,
  ai_600,
  ai_800,
  warning_50,
  warning_100,
  warning_200,
  warning_400,
  warning_600,
  warning_800);
export const Colors$isColors = (value) => value instanceof Colors;
export const Colors$Colors$transparent = (value) => value.transparent;
export const Colors$Colors$0 = (value) => value.transparent;
export const Colors$Colors$text_white = (value) => value.text_white;
export const Colors$Colors$1 = (value) => value.text_white;
export const Colors$Colors$text_body = (value) => value.text_body;
export const Colors$Colors$2 = (value) => value.text_body;
export const Colors$Colors$text_display = (value) => value.text_display;
export const Colors$Colors$3 = (value) => value.text_display;
export const Colors$Colors$gradient = (value) => value.gradient;
export const Colors$Colors$4 = (value) => value.gradient;
export const Colors$Colors$grey_50 = (value) => value.grey_50;
export const Colors$Colors$5 = (value) => value.grey_50;
export const Colors$Colors$grey_100 = (value) => value.grey_100;
export const Colors$Colors$6 = (value) => value.grey_100;
export const Colors$Colors$grey_200 = (value) => value.grey_200;
export const Colors$Colors$7 = (value) => value.grey_200;
export const Colors$Colors$grey_400 = (value) => value.grey_400;
export const Colors$Colors$8 = (value) => value.grey_400;
export const Colors$Colors$grey_600 = (value) => value.grey_600;
export const Colors$Colors$9 = (value) => value.grey_600;
export const Colors$Colors$grey_800 = (value) => value.grey_800;
export const Colors$Colors$10 = (value) => value.grey_800;
export const Colors$Colors$cream_50 = (value) => value.cream_50;
export const Colors$Colors$11 = (value) => value.cream_50;
export const Colors$Colors$cream_100 = (value) => value.cream_100;
export const Colors$Colors$12 = (value) => value.cream_100;
export const Colors$Colors$cream_200 = (value) => value.cream_200;
export const Colors$Colors$13 = (value) => value.cream_200;
export const Colors$Colors$cream_400 = (value) => value.cream_400;
export const Colors$Colors$14 = (value) => value.cream_400;
export const Colors$Colors$cream_600 = (value) => value.cream_600;
export const Colors$Colors$15 = (value) => value.cream_600;
export const Colors$Colors$cream_800 = (value) => value.cream_800;
export const Colors$Colors$16 = (value) => value.cream_800;
export const Colors$Colors$foam_50 = (value) => value.foam_50;
export const Colors$Colors$17 = (value) => value.foam_50;
export const Colors$Colors$foam_100 = (value) => value.foam_100;
export const Colors$Colors$18 = (value) => value.foam_100;
export const Colors$Colors$foam_200 = (value) => value.foam_200;
export const Colors$Colors$19 = (value) => value.foam_200;
export const Colors$Colors$foam_400 = (value) => value.foam_400;
export const Colors$Colors$20 = (value) => value.foam_400;
export const Colors$Colors$foam_600 = (value) => value.foam_600;
export const Colors$Colors$21 = (value) => value.foam_600;
export const Colors$Colors$foam_800 = (value) => value.foam_800;
export const Colors$Colors$22 = (value) => value.foam_800;
export const Colors$Colors$error_50 = (value) => value.error_50;
export const Colors$Colors$23 = (value) => value.error_50;
export const Colors$Colors$error_100 = (value) => value.error_100;
export const Colors$Colors$24 = (value) => value.error_100;
export const Colors$Colors$error_200 = (value) => value.error_200;
export const Colors$Colors$25 = (value) => value.error_200;
export const Colors$Colors$error_400 = (value) => value.error_400;
export const Colors$Colors$26 = (value) => value.error_400;
export const Colors$Colors$error_600 = (value) => value.error_600;
export const Colors$Colors$27 = (value) => value.error_600;
export const Colors$Colors$error_800 = (value) => value.error_800;
export const Colors$Colors$28 = (value) => value.error_800;
export const Colors$Colors$success_50 = (value) => value.success_50;
export const Colors$Colors$29 = (value) => value.success_50;
export const Colors$Colors$success_100 = (value) => value.success_100;
export const Colors$Colors$30 = (value) => value.success_100;
export const Colors$Colors$success_200 = (value) => value.success_200;
export const Colors$Colors$31 = (value) => value.success_200;
export const Colors$Colors$success_400 = (value) => value.success_400;
export const Colors$Colors$32 = (value) => value.success_400;
export const Colors$Colors$success_600 = (value) => value.success_600;
export const Colors$Colors$33 = (value) => value.success_600;
export const Colors$Colors$success_800 = (value) => value.success_800;
export const Colors$Colors$34 = (value) => value.success_800;
export const Colors$Colors$blue_50 = (value) => value.blue_50;
export const Colors$Colors$35 = (value) => value.blue_50;
export const Colors$Colors$blue_100 = (value) => value.blue_100;
export const Colors$Colors$36 = (value) => value.blue_100;
export const Colors$Colors$blue_200 = (value) => value.blue_200;
export const Colors$Colors$37 = (value) => value.blue_200;
export const Colors$Colors$blue_400 = (value) => value.blue_400;
export const Colors$Colors$38 = (value) => value.blue_400;
export const Colors$Colors$blue_600 = (value) => value.blue_600;
export const Colors$Colors$39 = (value) => value.blue_600;
export const Colors$Colors$blue_800 = (value) => value.blue_800;
export const Colors$Colors$40 = (value) => value.blue_800;
export const Colors$Colors$ai_50 = (value) => value.ai_50;
export const Colors$Colors$41 = (value) => value.ai_50;
export const Colors$Colors$ai_100 = (value) => value.ai_100;
export const Colors$Colors$42 = (value) => value.ai_100;
export const Colors$Colors$ai_200 = (value) => value.ai_200;
export const Colors$Colors$43 = (value) => value.ai_200;
export const Colors$Colors$ai_400 = (value) => value.ai_400;
export const Colors$Colors$44 = (value) => value.ai_400;
export const Colors$Colors$ai_600 = (value) => value.ai_600;
export const Colors$Colors$45 = (value) => value.ai_600;
export const Colors$Colors$ai_800 = (value) => value.ai_800;
export const Colors$Colors$46 = (value) => value.ai_800;
export const Colors$Colors$warning_50 = (value) => value.warning_50;
export const Colors$Colors$47 = (value) => value.warning_50;
export const Colors$Colors$warning_100 = (value) => value.warning_100;
export const Colors$Colors$48 = (value) => value.warning_100;
export const Colors$Colors$warning_200 = (value) => value.warning_200;
export const Colors$Colors$49 = (value) => value.warning_200;
export const Colors$Colors$warning_400 = (value) => value.warning_400;
export const Colors$Colors$50 = (value) => value.warning_400;
export const Colors$Colors$warning_600 = (value) => value.warning_600;
export const Colors$Colors$51 = (value) => value.warning_600;
export const Colors$Colors$warning_800 = (value) => value.warning_800;
export const Colors$Colors$52 = (value) => value.warning_800;

export const palette = /* @__PURE__ */ new Colors(
  "transparent",
  "#FFFFFF",
  "#454545",
  "#27272C",
  "linear-gradient(to right, #E6FAB5, #D3C4FB)",
  "#F8F8F8",
  "#F5F6F6",
  "#EAEBEC",
  "#DADAE2",
  "#B8B8C3",
  "#6F707C",
  "#FFFCF2",
  "#F6F3EB",
  "#EFECE2",
  "#E8E5D9",
  "#D7D5C9",
  "#78776F",
  "#F6FBFB",
  "#EBF3F3",
  "#E0ECEC",
  "#D2E0E0",
  "#B7C7C7",
  "#5C7B7B",
  "#FFF5F5",
  "#FFEEEE",
  "#FFE1E1",
  "#FBC4C4",
  "#FB9D9D",
  "#DB1414",
  "#F7FCEA",
  "#F0FDD1",
  "#F0FDD1",
  "#D5F684",
  "#CBF26C",
  "#597D04",
  "#F5F9FF",
  "#EEF4FE",
  "#E5EFFF",
  "#D6E6FF",
  "#B7CFF2",
  "#2E6BC5",
  "#F9F8FE",
  "#F9F8FE",
  "#ECE5FF",
  "#D3C4FB",
  "#C4AEFF",
  "#7B57DB",
  "#FFF5E4",
  "#FFEFD6",
  "#FFE2B7",
  "#FFD089",
  "#FFBC57",
  "#F29100",
);

export const light = palette;
